module.exports = {"id":"205192","name":"Denis Suárez","rating":"80","photo":"./data/images/photos/3/205192.png","club":{"name":"FC Barcelone","logo":"./data/images/clubs/FCBarcelone.png"},"positions":["MC","MG","MD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DenisSuarez0.json
// module id = 1049
// module chunks = 0